module.exports = __webpack_public_path__ + "static/isobar-logo-white-521017761dfff5ab45c2eedb8f133295.png";